import { ROUTES } from 'application/constants'
import { hashUserKey } from 'application/storage'
import React from 'react'
import { Navigate } from 'react-router-dom'

const PinRedirect = () => {
    return <Navigate to={ROUTES.ENTER_PIN + '/' + hashUserKey.get()} />
}

export default PinRedirect